import { useEffect, useContext, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Container, Box, Button } from '@mui/material';
import { getReportParams } from '../../api/reporting';

import { ReportingContext } from './ReportingContainer';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import dayjs from 'dayjs';

export const ReportParams = () => {
  const [params, setParams] = useState([]);
  const { reportId, reportName, setEndpoint, setEndpointParams, navToReportingPage } = useContext(ReportingContext);

  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);

  const generateReport = async () => {
    let queryParams = {};
    if (params.find((v) => v.data === 'Created' && v.Type === 'Date')) {
      if (!startDate) queryParams['startDate'] = undefined;
      else queryParams['startDate'] = dayjs(startDate).format('YYYY-MM-DD HH:mm:ss');
      if (!endDate) {
        queryParams['endDate'] = undefined;
      } else {
        queryParams['endDate'] = dayjs(endDate)
          .set('hour', 23)
          .set('minute', 59)
          .set('second', 59)
          .format('YYYY-MM-DD HH:mm:ss');
      }
    }
    console.log('HSDIJ', queryParams);
    setEndpointParams(queryParams);
    navToReportingPage(2);
  };

  useEffect(() => {
    const fetch = async () => {
      const params = await getReportParams(reportId);
      setEndpoint(params[0].endPoint);
      setParams(JSON.parse(params[0].parameters));
    };
    fetch();
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid className="two-column-divs right-container">
        <Box
          sx={{
            mb: 6,
            mt: 2,
            fontSize: '24px',
            fontWeight: '100',
            fontFamily: 'Roboto',
          }}
          className="header-search"
        >
          <span>{reportName}</span>
        </Box>
        {params.find((v) => v.data === 'Created' && v.Type === 'Date') && (
          <Container>
            <Box
              sx={{
                mb: 2,
                fontSize: '15px',
                fontWeight: '100',
                fontFamily: 'Roboto',
              }}
              className="header-search"
            >
              Created
            </Box>
            <Box sx={{ display: 'flex', direction: 'row' }}>
              <DatePicker id={'startDate'} onChange={(e) => setStartDate(e)} value={startDate} format="DD/MM/YYYY" />

              <DatePicker id={'endDate'} onChange={(e) => setEndDate(e)} value={endDate} format="DD/MM/YYYY" />
            </Box>
          </Container>
        )}
        <Button onClick={generateReport}>Generate report</Button>
        <Button
          sx={{ width: '80px' }}
          variant="text"
          startIcon={<ArrowBackIosIcon />}
          onClick={() => navToReportingPage(null)}
        >
          Back
        </Button>
      </Grid>
    </LocalizationProvider>
  );
};
